<template>
	<div class="item__wrapper">
		<div class="pl-3 mb-3">
			<div>
				<div class="item__title" v-if="fieldsConfig.title && !fieldsConfig.showMainCheckbox">{{ fieldsConfig.title }}</div>
				<b-form-checkbox v-model="config.show" v-else-if="fieldsConfig.title">
					<span>{{ fieldsConfig.title }}</span>
				</b-form-checkbox>
			</div>
            <div v-if="!config.show" class="item_default_settings">
                <div class="item_def_sett_title">Basic screen settings:</div>
                <div class="config_override_wrapper">
                    <b-form-checkbox v-model="config.showSocialTitle" class="input_cb">
                        <span class="checkbox-label">Show social buttons title</span>
                    </b-form-checkbox>
                    <md-field class="screen__input" v-if="config.showSocialTitle">
                        <label>Social buttons title</label>
                        <md-input maxlength="200" v-model="config.social_title"/>
                    </md-field>
                </div>
            </div>
			<div class="item__checkbox" v-if="config.show">
				<b-form-checkbox v-model="config.overrideBasicSettings" v-if="fieldsConfig.showOverrideBasicSettings">
					<span>{{ translate('sldOverrideSettings') }}</span>
				</b-form-checkbox>
				<div v-if="config.overrideBasicSettings">
					<div class="screen__inputs" >
						<md-field class="screen__input">
							<label>{{ translate('sldScreenTitle') }}</label>
							<md-input maxlength="100" v-model="config.title"/>
						</md-field>
						<div class="screen__background">
							<div>{{ translate('sldScreenBackground') }}</div>
							<verte picker="square" v-model="config.background" model="hex"></verte>
						</div>
					</div>
                    <div class="subtitle_wrapper">
                        <b-form-checkbox v-model="config.overrideSubtitle" class="input_cb">
                            <span class="checkbox-label">Override default subtitle</span>
                        </b-form-checkbox>
                        <md-field class="screen__input" v-if="config.overrideSubtitle"
                        style="margin-left: 24px;">
                            <label>{{ translate('sldScreenSubTitle') }}</label>
                            <md-input maxlength="200" v-model="config.subtitle"/>
                        </md-field>
                    </div>
                    <div class="config_override_wrapper">
                        <b-form-checkbox v-model="config.overrideAutoCameraOpenFlow" class="input_cb">
                            <span class="checkbox-label">Override auto camera open flow</span>
                        </b-form-checkbox>
                        <b-form-checkbox v-model="config.auto_open_camera" class="input_cb" v-if="config.overrideAutoCameraOpenFlow"
                        style="margin-left: 24px;">
                            <span class="checkbox-label">Auto open camera</span>
                        </b-form-checkbox>
                    </div>
					<div class="countSelected__inputs" >
						<md-field class="countSelected__input" v-if="fieldsConfig.showMaxCountSelectedItems">
							<label>{{ translate('sldMaxCount') }}</label>
							<md-input v-model="config.maxCountSelectedItems"/>
							<span class="md-helper-text">{{ translate('sldEnterForUnlimited') }}</span>
						</md-field>
						<div class="pl-3 mb-3" v-if="fieldsConfig.showCommentAlways">
							<b-form-checkbox v-model="config.showCommentAlways">
								<span class="checkbox-label">{{ translate('sldShowComment') }}</span>
							</b-form-checkbox>
						</div>
					</div>
				</div>
                <div class="pl-3 mb-3" v-if="fieldsConfig.showForce">
                    <b-form-checkbox v-model="config.force">
                        <span class="checkbox-label">{{translate('serviceLogForce')}}</span>
                    </b-form-checkbox>
                </div>
				<div class="pl-3 mb-3" v-if="fieldsConfig.showRequirePin">
					<b-form-checkbox v-model="config.requiredPin">
						<span class="checkbox-label">{{translate('serviceLogRequirePin')}}</span>
					</b-form-checkbox>
				</div>
				<div class="pl-3 mb-3" v-if="fieldsConfig.showServiceLogPopup">
					<b-form-checkbox v-model="config.serviceInfoPopup">
						<span class="checkbox-label">{{ translate('serviceLogInfoPopup') }}</span>
					</b-form-checkbox>
				</div>
				<div class="pl-3 mb-3" v-if="fieldsConfig.showPlacementEdit">
					<b-form-checkbox v-model="config.placementEdit">
						<span class="checkbox-label">{{ translate('serviceLogPlacementEdit') }}</span>
					</b-form-checkbox>
				</div>
				<b-form-checkbox v-model="config.overrideBasicBlocks" v-if="fieldsConfig.showOverrideBasicBlocks">
					<span>{{ translate('sldOverrideBlocks') }}</span>
				</b-form-checkbox>
				<div class="draggable-items" v-if="config.overrideBasicBlocks">
					<div class="item__title">{{ translate('sldBlocks') }}</div>
					<draggable v-model="config.blocks" :disabled="isMobile">
						<div class="block" v-for="(block, index) in config.blocks" :key="block.id">
							<div class="block__wrapper">
								<div class="block-icon">
									<img src="@/assets/icons/icon_grey-up.svg" alt="" class="ic-block-action"
                                         v-if="config.blocks && index != 0" @click="onMoveBlockUp(block, index)">
									<img src="@/assets/icons/menu.svg" alt="" v-if="!isMobile">
                                    <div class="empty" v-else />
									<img src="@/assets/icons/icon_grey-down.svg" alt="" class="ic-block-action"
                                         v-if="config.blocks && index != (config.blocks.length-1)" @click="onMoveBlockDown(block, index)">
								</div>
								<div class="block-content" v-if="fieldsConfig.blocksHaveIcons">
									<secLevelDropdown :blockValues="blockValues" :secLevelBlock="block"></secLevelDropdown>
                                    <div style="display: flex; flex-direction: column;">
                                        <md-field class="block-input">
                                            <label>{{ translate('sldText') }}</label>
                                            <md-input maxlength="50" v-model="block.text"/>
                                        </md-field>
                                        <div class="config_override_wrapper">
                                            <b-form-checkbox v-model="block.overrideAutoCameraOpenFlow" class="input_cb">
                                                <span class="checkbox-label" style="font-size: 14px;">Override auto camera open flow</span>
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="block.auto_open_camera" class="input_cb" v-if="block.overrideAutoCameraOpenFlow"
                                                             style="margin-left: 24px;">
                                                <span class="checkbox-label">Auto open camera</span>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
									<div class="trash-icon" @click="deleteBlock(config.blocks, index)">
										<img src="@/assets/icons/trash-can-outline.svg" alt="">
									</div>
								</div>
								<div class="block-content" v-else>
                                    <div style="display: flex; flex-direction: column; width: 100%;">
									<b-form-input list="my-list-id" v-model="block.text"></b-form-input>
                                        <datalist id="my-list-id">
                                            <option v-for="(item, index) in blockValues" :key="index" @click="setBlockData(item, block)">{{ item.text }}</option>
                                        </datalist>
                                        <div class="config_override_wrapper">
                                            <b-form-checkbox v-model="block.overrideAutoCameraOpenFlow" class="input_cb">
                                                <span class="checkbox-label" style="font-size: 14px;">Override auto camera open flow</span>
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="block.auto_open_camera" class="input_cb" v-if="block.overrideAutoCameraOpenFlow"
                                                             style="margin-left: 24px;">
                                                <span class="checkbox-label">Auto open camera</span>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
									<div class="trash-icon" @click="deleteBlock(config.blocks, index)">
										<img src="@/assets/icons/trash-can-outline.svg" alt="">
									</div>
								</div>
							</div>
						</div>
						<div class="add_block_btn" @click="onAddBlockClick(config.blocks)">
							<img src="@/assets/icons/secLevelAddBlock.svg" alt="">
						</div>
					</draggable>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import errorMixin from "@/mixins/errorMixin";
import draggable from "vuedraggable";
import secLevelDropdown from "../other/secLevelDropdown";
import Verte from 'verte';
import 'verte/dist/verte.css';

export default {
	name: "secondLevelBlock.vue",
	mixins: [errorMixin],
	components: {
		Verte,
		draggable,
		secLevelDropdown
	},
	data() {
		return {
            isMobile: window.innerWidth <= 1000 ? true : false,
        }
	},
	props: ["config", "blockValues", "fieldsConfig"],
	methods: {
		onAddBlockClick(blocks) {
			let data = {
				text: '',
				value: '',
			}
			if (this.fieldsConfig.blocksHaveIcons) data.icon = ''
			blocks.push(data)
		},
		deleteBlock(blocks, index) {
			blocks.splice(index, 1)
		},
		setBlockData(selectedItem, block) {
			block.text = selectedItem.text
			block.value = selectedItem.value
		},
        onMoveBlockUp(block, index) {
            if(!this.config.blocks || index == 0) return
            this.config.blocks.splice(index, 1)
            this.config.blocks.splice(index - 1, 0, block)
        },
        onMoveBlockDown(block, index) {
            if(!this.config.blocks || (this.config.blocks.length - 1) == index) return
            this.config.blocks.splice(index, 1)
            this.config.blocks.splice(index + 1, 0, block)
        },

	}

}
</script>

<style scoped>
.item__wrapper {
	max-width: 560px;
	width: 100%;
	background: #F3F3F3;
	border: 1px solid #000000;
	box-sizing: border-box;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 4px;
	padding: 7px 33px 21px 10px;
	margin-bottom: 20px;
}


.screen__inputs {
	display: flex;
}

.screen__input:last-child {
	margin-left: 22px;
}

.subtitle_wrapper {
    margin-top: 8px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
}
.subtitle_wrapper .screen__input:last-child {
    margin-left: 0;
}
.config_override_wrapper {
    margin-top: 8px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
}
.config_override_wrapper .screen__input:last-child {
    margin-left: 0;
}
.config_override_wrapper.bordered {
    border-top: 1px solid #8b8b8b;
    border-bottom: 1px solid #8b8b8b;
    padding-top: 4px;
    padding-bottom: 8px;
}

.screen__background {
	display: flex !important;
	justify-content: end;
	flex-direction: row;
	align-items: center;
	width: 100%;
	min-height: 48px;
	margin: 4px 0 24px;
	padding-top: 16px;
	position: relative;
}

.countSelected__inputs {
	display: flex;
	align-items: center;
}

.countSelected__input {
	width: 100%;
	max-width: 291px;
}

.block__wrapper {
	display: flex;
	align-items: center;
	margin-top: 15px;
}

.block-content {
	margin-left: 10px;
	width: 100%;
	background: #FFFFFF;
	box-sizing: border-box;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 9px;
	position: relative;
}
.block-input {
    width: 250px;
}

.block-image img {
	width: auto;
}

.block-input:first-child {
	margin-right: 20px !important;
}

.draggable-items {
	margin-top: 15px;
}

.md-menu-content.md-select-menu .md-list {
	display: flex !important;
	flex-direction: row !important;
}

.md-list-item-text div {
	display: flex !important;
	flex-direction: column;
	align-items: center;
}

.md-list-item-text img {
	height: 50px;
	width: 50px;
}

.md-menu-content {
	display: flex !important;
	flex-direction: row !important;
}

.block-icon {
	display: flex !important;
	flex-direction: column;
    cursor: pointer;
}

.trash-icon {
	cursor: pointer;
	position: absolute;
	top: 3px;
	right: 5px;
}

.trash-icon img {
	width: 13px;
	height: 13px;
}

.block-icon img {
	width: 20px;
	height: 30px;
}

.block-icon .empty {
	height: 30px;
}

.ic-block-action:hover{
    background: #bbbbbb;
}

.add_block_btn {
	cursor: pointer;
	display: flex;
	justify-content: center;
	margin-top: 15px;
	align-items: center;
}

.verte {
	margin-left: 10px;
}

.item_default_settings {
    margin-top: 12px;
    border-top: 1px solid black;
    padding-top: 8px;
}
.item_def_sett_title {
    margin-bottom: 4px;
}

@media screen and (max-width: 426px) {
	.screen__inputs {
		flex-direction: column;
	}

	.screen__background {
		justify-content: start;
	}

	.countSelected__inputs {
		flex-direction: column;
		align-items: start;
	}

	.pl-3, .px-3 {
		padding-left: 0 !important;
	}

	.block-content {
		flex-direction: column;
	}

	.manage {
		width: auto;
	}

}
</style>
